import React, { useEffect, useState } from "react";
import axios from "axios";
import "./CategoryCards.css";
import { useNavigate } from "react-router-dom";

const DoctorCategoryCards = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          "https://api.swasthmitra.com/api/doctorCategory/selected"
        );
        setCategories(response.data.categories);
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch categories. Please try again later.");
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  // Split categories into two halves
  const splitCategories = () => {
    const mid = Math.ceil(categories.length / 2);
    return [categories.slice(0, mid), categories.slice(mid)];
  };

  // Get the two halves of categories
  const [firstHalf, secondHalf] = splitCategories();

  const handleCategoryClick = (categoryName) => {
    navigate(`/category/${encodeURIComponent(categoryName)}`);
  };

  if (loading) return <div className="text-center mt-10">Loading...</div>;

  if (error)
    return <div className="text-center mt-10 text-red-500">{error}</div>;

  return (
    <div className="container1">
      {/* First row for the first half of categories */}
      {/* <h3>Browse By Healthcare Departments</h3> */}
      <div className="grid-container1">
        {firstHalf.map((category) => (
          <div
            key={category._id}
            className="icon-card1 hover:shadow-lg transition-shadow cursor-pointer"
            onClick={() => handleCategoryClick(category.name)}
          >
            <img
              src={category.imageUrl}
              alt={category.name}
              className="icon-image1"
            />
            <h2 className="icon-title1">{category.name}</h2>
          </div>
        ))}
      </div>

      {/* Second row for the second half of categories */}
      <div className="grid-container1">
        {secondHalf.map((category) => (
          <div
            key={category._id}
            className="icon-card1 hover:shadow-lg transition-shadow cursor-pointer"
            onClick={() => handleCategoryClick(category.name)}
          >
            <img
              src={category.imageUrl}
              alt={category.name}
              className="icon-image1"
            />
            <h2 className="icon-title1">{category.name}</h2>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DoctorCategoryCards;